<template>
  <v-menu
      top
      offset-y
      :value='isOpen'
      @input='handleOpen'
    >
    <v-card class="popup-root">
      <v-card-text>
      <speed-slider-global 
        :hide-label='true' 
        :hide-ticks='false' 
        :tick-labels="tickLabels"
        />
      </v-card-text>
    </v-card>

    <template v-slot:activator="{ on, attrs }">
      <v-btn small 
        class="speed-slider-btn"
        :elevation='0' 
        v-bind="attrs"
        v-on="on">
        {{ speedLabel }}
      </v-btn>
    </template>

  </v-menu>
</template>

<script>
import { defineComponent, computed, inject, ref } from 'vue'
import SpeedSliderGlobal from './SpeedSliderGlobal.vue';
import { useEvent } from '../../plugins/vue-gtag';

const tickLabels = [
  '0.5X',
  '0.75X',
  '1X',
  '1.25X',
  '1.5X'
]

export default defineComponent({
  components: {
    SpeedSliderGlobal,
  },
  props: {
    open: Boolean
  },
  setup(props, context) {
    const open = ref(false);
    const speed = inject('speed');
    const gaSpeedMenu = useEvent('speed_menu');

    const speedLabel = computed(()=>{
      return tickLabels[speed.value - 1]
    })

    const handleOpen = ()=>{
      open.value = !isOpen;
      context.emit('update:open', !isOpen);
      gaSpeedMenu(open.value);
    }
    
    const isOpen = computed(()=>{
      return props.open != null ? props.open : open.value;
    })

    return {
      tickLabels,
      speedLabel,
      handleOpen,
      isOpen
    }
  },
})
</script>

<style lang="scss" scoped>
.popup-root {
  min-width: 260px;
  width: min(400px, 100vw)
}
</style>